import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

export default function AguaEnfriamiento() {
  const [aguaEnfriamientoDia, setAguaEnfriamientoDia] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [aguaEnfriamientoA, setAguaEnfriamientoA] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [aguaEnfriamientoB, setAguaEnfriamientoB] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 10,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);
 
    populateAguaEnfriamientoDia(data);
    populateAguaEnfriamientoA(data);
    populateAguaEnfriamientoB(data)

      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateAguaEnfriamientoDia(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua a Torre Enfriamiento Dia"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setAguaEnfriamientoDia({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAguaEnfriamientoA(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua a Torre Enfriamiento Turno A"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setAguaEnfriamientoA({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateAguaEnfriamientoB(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Agua a Torre Enfriamiento Turno B"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setAguaEnfriamientoB({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Totalizador Agua a Torre Enfriamiento"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Totalizador Agua a Torre Enfriamiento Dia --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua a Torre Enfriamiento Dia"
              data={aguaEnfriamientoDia.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Agua a Torre Enfriamiento Turno A --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua a Torre Enfriamiento Turno A"
              data={aguaEnfriamientoA.value}
              yAxis={0}
            />

            {/** -------------------------------- Totalizador Agua a Torre Enfriamiento Turno B --------------------------------------- */}
            <Chart.Area
              name="Totalizador Agua a Torre Enfriamiento Turno B"
              data={aguaEnfriamientoB.value}
              yAxis={0}
            />


            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={aguaEnfriamientoDia.fecha} />

            <Chart.YAxis
              labelSuffix=" m3"
              title="Uso de agua refrigeración, m3"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
